/**
 * GENERATED CODE - DO NOT MODIFY
 */
import { type HeadersMap, XRPCError } from '@atproto/xrpc'
import { type ValidationResult, BlobRef } from '@atproto/lexicon'
import { CID } from 'multiformats/cid'
import { validate as _validate } from '../../../../lexicons.js'
import {
  type $Typed,
  is$typed as _is$typed,
  type OmitKey,
} from '../../../../util.js'

const is$typed = _is$typed,
  validate = _validate
const id = 'app.bsky.video.uploadPart'

export type QueryParams = {
  jobId: string
  partNumber: number
}
export type InputSchema = string | Uint8Array | Blob

export interface OutputSchema {
  partNumber: number
  sizeBytes: number
}

export interface CallOptions {
  signal?: AbortSignal
  headers?: HeadersMap
  qp?: QueryParams
  encoding?: 'application/octet-stream'
}

export interface Response {
  success: boolean
  headers: HeadersMap
  data: OutputSchema
}

export class UploadNotFoundError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export class UploadExpiredError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export class InvalidPartNumberError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export class PartSizeMismatchError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export class UploadNotReadyError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export class UploadFailedError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export class UploadAbortedError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export class UploadAlreadyCompletedError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export class ServiceOverloadedError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export function toKnownErr(e: any) {
  if (e instanceof XRPCError) {
    if (e.error === 'UploadNotFound') return new UploadNotFoundError(e)
    if (e.error === 'UploadExpired') return new UploadExpiredError(e)
    if (e.error === 'InvalidPartNumber') return new InvalidPartNumberError(e)
    if (e.error === 'PartSizeMismatch') return new PartSizeMismatchError(e)
    if (e.error === 'UploadNotReady') return new UploadNotReadyError(e)
    if (e.error === 'UploadFailed') return new UploadFailedError(e)
    if (e.error === 'UploadAborted') return new UploadAbortedError(e)
    if (e.error === 'UploadAlreadyCompleted')
      return new UploadAlreadyCompletedError(e)
    if (e.error === 'ServiceOverloaded') return new ServiceOverloadedError(e)
  }

  return e
}
